import { Component } from "@angular/core";
import {RegionKey} from '../../api/models/region-key';
import {OccupationKey} from '../../api/models/occupation-key';
import {IndustryKey} from '../../api/models/industry-key';
import {JobDepartment} from '../../api/models/job-department';
import {TextSearchValue} from '../../elements/filter-editor/text-search-filter/text-search-filter.component';
import {JobSeniority} from '../../api/models/job-seniority';
import {Company} from '../../api/models/company';
import {TitleKey} from '../../api/models/title-key';

@Component({
  selector: "test-page",
  templateUrl: "./test-page.component.html",
  styleUrls: ["./test-page.component.css"],
})
export class TestPageComponent {
  public regionDataSource: RegionKey[] = [];
  public occupationDataSource: OccupationKey[] = [];
  public industryDataSource: IndustryKey[] = [];
  public jobDepartmentSelectedValues: TextSearchValue<JobDepartment> = {
    searchTerms: [],
    selectedValues: []
  }
  public jobSenioritySelectedValues: TextSearchValue<JobSeniority> = {
    searchTerms: [],
    selectedValues: []
  }
  public companySelectedValues: TextSearchValue<Company> = {
    searchTerms: [],
    selectedValues: []
  }
  public titleValues: TitleKey[] = [];
  public otherValues: TitleKey[] = [];

  doSwitch() {
    var tmp = this.titleValues;
    this.titleValues = this.otherValues;
    this.otherValues = tmp;
  }
}
